module.exports = __webpack_public_path__ + "img/pr-3.28c54b04.png";